@if (isVisible()) {
  <app-component-factory
    [data]="data"
    [componentClass]="$any(componentClass)"
    (isVisibleChanged)="isVisible.set($event)"
  ></app-component-factory>
}
